<div class="dark-light-switch-btn">
    <button (click)="toggleTheme()" [class.active]="themeService.isDark()">
        <i class='bx bxs-moon'></i>
    </button>
</div>